import handleArrayOf from 'app/event-monitoring/event-schemas/panel/handle-array-of';

export default function transformSchemaResponse(response) {
  if (!response?.details) return null;
  const details = JSON.parse(atob(response.details));
  return handleArrayOf(details);
}
